// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_NwbVXM","footer":"ob_n8Wggn","newWindowIcon":"ob_gl6gyb","mediaCard":"ob_kotPxI"};